import type { ReactNode } from 'react';

export interface NavItem {
  to: string;
  label: string;
  icon: ReactNode;
}

const ICON_CLASS = 'w-6 h-6';
const STROKE_PROPS = {
  xmlns: 'http://www.w3.org/2000/svg',
  className: ICON_CLASS,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export const ADMIN_NAV_ITEM: NavItem = {
  to: '/admin',
  label: 'Admin',
  icon: (
    <svg {...STROKE_PROPS}>
      <path d="M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),
};

export const NAV_ITEMS: NavItem[] = [
  {
    to: '/spots',
    label: 'Spots',
    icon: (
      <svg {...STROKE_PROPS}>
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
        <circle cx="12" cy="9" r="2.5" />
      </svg>
    ),
  },
  {
    to: '/catches',
    label: 'Catches',
    icon: (
      <svg {...STROKE_PROPS}>
        <path d="M3 12c3-4 7-6 11-6 3 0 5 1 7 3-1 3-1 3 0 6-2 2-4 3-7 3-4 0-8-2-11-6z" />
        <circle cx="16" cy="11" r="0.6" fill="currentColor" stroke="none" />
        <path d="M3 12c-1-1-1-3 0-5M3 12c-1 1-1 3 0 5" />
      </svg>
    ),
  },
  {
    to: '/sessions',
    label: 'Sessions',
    icon: (
      <svg {...STROKE_PROPS}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </svg>
    ),
  },
  {
    to: '/clubs',
    label: 'Clubs',
    icon: (
      <svg {...STROKE_PROPS}>
        <circle cx="9" cy="9" r="3.25" />
        <path d="M2.5 19a6.5 6.5 0 0 1 13 0" />
        <circle cx="17" cy="8" r="2.5" />
        <path d="M15 13.5c2.6 0 5 1.7 5.5 4.5" />
      </svg>
    ),
  },
];
